/**
 * Returns the start and end datetime of a given year,
 * both at 00:00:00.
 * @param {number} year - e.g. 2025
 * @returns {{ startDate: string, endDate: string }}
 */
export function getYearRange(year) {
  const pad = n => String(n).padStart(2, '0');

  // start: Jan 1st at 00:00:00
  const start = new Date(year, 0, 1, 0, 0, 0);

  // end: Dec 31st at 00:00:00
  const end = new Date(year, 11, 31, 0, 0, 0);

  const fmt = dt =>
    `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}` +
    ` ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;

  return {
    startDate: fmt(start),
    endDate: fmt(end),
  };
}

/**
 * Returns the start and end datetime of a given month in a given year,
 * both at 00:00:00.
 * @param {number} monthIndex - 0 for January through 11 for December
 * @param {number} year
 * @returns {{ startDate: string, endDate: string }}
 */
export function getMonthRange(monthIndex, year) {
  const pad = n => String(n).padStart(2, '0');
  const m = monthIndex; // now directly 0–11

  // start: 1st day of month at 00:00:00
  const start = new Date(year, m, 1, 0, 0, 0);

  // end: last day of month at 00:00:00
  // (day 0 of next month is last day of current)
  const end = new Date(year, m + 1, 0, 0, 0, 0);

  const fmt = dt =>
    `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}` +
    ` ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;

  return {
    startDate: fmt(start),
    endDate: fmt(end),
  };
}
